// core/data/policies/index.ts — the policy document registry.
//
// One place that knows every document, so routes, the index page, the More-hub
// rows and the signup links all derive from the same list rather than
// hand-maintaining four copies of it.

import type { PolicyDocument, PolicyDocumentId } from '@/core/models/policy';
import { communityGuidelines } from './guidelines';
import { termsOfService } from './terms';
import { privacyPolicy } from './privacy';
import { moderationPolicy } from './moderation';

/** Display order — Terms first, then the documents it points at. */
export const POLICY_DOCUMENTS: PolicyDocument[] = [
  termsOfService,
  privacyPolicy,
  communityGuidelines,
  moderationPolicy,
];

export function getPolicy(id: string): PolicyDocument | undefined {
  return POLICY_DOCUMENTS.find((d) => d.id === id);
}

export type { PolicyDocument, PolicyDocumentId };
export { communityGuidelines, termsOfService, privacyPolicy, moderationPolicy };
